import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

// Tipos de contingencia según AFIP WSRemCarne
const TIPOS = [
  { code: 4, label: "Accidente vial" },
  { code: 5, label: "Robo de mercadería" },
  { code: 6, label: "Destrucción de mercadería" },
  { code: 7, label: "Otros siniestros" },
  { code: 8, label: "Anulación total y regreso a planta" },
];

export default function ContingenciaRECDialog({ rec, onOpenChange, onSuccess }) {
  const open = !!rec;
  const [tipo, setTipo] = useState("7");
  const [observacion, setObservacion] = useState("Error");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) { setTipo("7"); setObservacion("Error"); }
  }, [open]);

  const submit = async () => {
    if (!rec) return;
    setSending(true);
    try {
      await api.post(`/rec/${rec.id}/contingencia`, {
        tipo: Number(tipo),
        observacion: observacion || "Error",
      });
      toast.success(`Contingencia informada a AFIP · REC ${rec.numero_formateado} anulado`);
      onSuccess?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al informar contingencia");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="rec-contingencia-dialog">
        <DialogHeader>
          <DialogTitle>Informar contingencia · REC {rec?.numero_formateado}</DialogTitle>
          <DialogDescription>
            Reporta una contingencia AFIP sobre este remito emitido. Esta acción marca el REC como anulado en el sistema.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Tipo de contingencia *</Label>
            <Select value={tipo} onValueChange={setTipo}>
              <SelectTrigger data-testid="contingencia-tipo-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {TIPOS.map((t) => (
                  <SelectItem key={t.code} value={String(t.code)}>
                    {t.code} · {t.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Observación *</Label>
            <Input
              data-testid="contingencia-observacion-input"
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              placeholder="Error"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={submit} disabled={sending} data-testid="contingencia-submit-btn">
            {sending ? "Enviando…" : "Informar contingencia"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
